// src/components/suppliers/Table/SuppliersTableColumns.jsx

const SuppliersTableColumns = [
    { id: "image", labelAr: "الصورة", labelEn: "Logo", sortable: false },
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "phone", labelAr: "الهاتف", labelEn: "Phone", sortable: false },
    { id: "email", labelAr: "البريد الإلكتروني", labelEn: "Email", sortable: false },
    { id: "services_count", labelAr: "عدد الخدمات", labelEn: "Services", sortable: false },
];

export default SuppliersTableColumns;
